import axios from "axios";
import { useEffect, useState } from "react";
import urls from "../urls";
import Select from "react-select";

const BeneficairySelectionForm = ({ onSelect }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    axios
      .get(urls.getBeneficiaries, {
        params: { faculty_id },
      })
      .then((res) => {
        const { results } = res.data;
        const options = results?.map((obj) => ({
          label: obj.name,
          value: obj.id, // Fixed typo (was 'vlaue')
        }));
        setOptions(options);
      });
  }, []);

  const handleChange = (selectedOption) => {
    if (onSelect) {
      onSelect(selectedOption);
    }
  };

  return (
    <div className="mb-3">
      <Select
        options={options}
        placeholder={"إختر اسم المستغل "}
        isRtl={true}
        onChange={handleChange}
      />
    </div>
  );
};

export default BeneficairySelectionForm;
